import { showLoader, hideLoader } from '../../../Shared/Loader';
import { Ajax } from '../../../components/Ajax';
import { ApiUrl } from '../../../project/Defines';
import { message } from 'antd';
import { dispatchCustomEvent } from '../../../project/utilities';
import FileSaver from 'file-saver';

const loaderName = 'TRANSLATION_FILE_UPLOAD_LOADER';
const exportLoaderName = "TRANSLATION_FILE_UITRANSLATION_LOADER";

export function TranslationImport(data, listUpdateEvent, successCallback) {
    showLoader(loaderName);

    Ajax.post({
        url: ApiUrl.UITranslationsImport,
        data: {
            file: data && data.file
        },
        success: (response) => {
            if (!response.HasError) {
                successCallback && successCallback(response);
                dispatchCustomEvent(listUpdateEvent);
                hideLoader(loaderName);
            } else {
                message.error(response.message);
                hideLoader(loaderName);
            }
        }
    });
}

export function TranslationExport() {
    showLoader(exportLoaderName);

    Ajax.download({
        url: ApiUrl.UITranslationsExport,
        data: {},
        //autoDownload: false,
        success: (blob) => {
            FileSaver.saveAs(blob, "UITranslation.xlsx");
            hideLoader(exportLoaderName);
        },
        error: () => {
            hideLoader(exportLoaderName);
        }
    });
}